import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { useAuthContext } from '.';

interface Props {
  path: string;
  children: React.ReactNode;
}

export const GuardedRoute = ({ children, ...rest }: Props) => {
  const { isAuthorized } = useAuthContext();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthorized() ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};
